<template>
  <RetailAnalytics />
</template>

<script>
import RetailAnalytics from "@/components/analytics/RetailAnalytics";

export default {
  components: {
    RetailAnalytics,
  },
};
</script>
